import React from "react"
import styled from "styled-components"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import DesignTokens from "./designTokens"
import { Col, Row } from "react-grid-system"
import TextBlock from "./textBlock"
import TableBlock from "./tableBlock"
import HeroBlock from "./heroBlock"

const TabBlock = ({ tabs }) => {
  return (
    <Wrapper>
      <Row>
        <Col>
          <Tabs>
            <StyledTabList>
              {tabs.map(tab => (
                <Tab key={tab.id}>{tab.title}</Tab>
              ))}
            </StyledTabList>
            {tabs.map(tab => (
              <TabPanel key={tab.id}>
                {tab.content.map(section => (
                  <section key={section.id}>
                    {section.model.apiKey === "text_block" && (
                      <TextBlock
                        title={section.title}
                        text={section.text}
                        highlight={section.highlight}
                      />
                    )}
                    {section.model.apiKey === "table_block" && (
                      <TableBlock title={section.title} table={section.table} />
                    )}
                    {section.model.apiKey === "hero_block" && (
                      <HeroBlock
                        title={section.title}
                        text={section.text}
                        image={section.image}
                        gallery={section.gallery}
                        documents={section.documents}
                      />
                    )}
                  </section>
                ))}
              </TabPanel>
            ))}
          </Tabs>
        </Col>
      </Row>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${DesignTokens.colors.white};
`

const StyledTabList = styled(TabList)`
  list-style-type: none;
  padding: 0;
  margin: 0;
  margin-bottom: 3rem;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  overflow-x: auto;
  max-width: 100%;
  flex-wrap: nowrap;
  color: ${DesignTokens.colors.black};
  & > li {
    white-space: nowrap;
    flex-shrink: 0;
    background-color: ${DesignTokens.colors.primary[100]};
    color: ${DesignTokens.colors.tertiary[300]};
    padding: ${DesignTokens.spacing[7]};
    border: 1px solid ${DesignTokens.colors.primary[100]};
    border-bottom: 1px solid ${DesignTokens.colors.tertiary[100]};
    /* flex: 1; */
    &:hover {
      cursor: pointer;
      color: ${DesignTokens.colors.primary[500]};
    }
    &.react-tabs__tab--selected {
      color: ${DesignTokens.colors.primary[500]};
      background-color: white;
      border: 1px solid ${DesignTokens.colors.tertiary[100]};
      border-bottom: 1px solid white;
    }
  }
  @media screen and (max-width: 767px) {
    & > li {
      padding: ${DesignTokens.spacing[4]};
    }
  }
`

export default TabBlock
